<template>
  <div class="home">
    <div class="box">
      <div class="box_left">
        <div class="subject">
          <el-carousel :interval="5000" arrow="always" height="470" style="width: 100%; height: 100%">
            <el-carousel-item v-for="item in Carousel" :key="item" style="width: 100rem; height: 47rem">
              <img :src="item.img" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="notice">
          <div class="notice_title">
            <div class="left">
              <div class="title">
                <img src="../assets/association.png" alt="" />协会通知
              </div>
              <div class="detail" @click="detail('/naturals/companyNotice', '协会通知')">
                更多<span>></span>
              </div>
            </div>
            <div class="left">
              <div class="title" style="margin-left: 6rem">
                <img src="../assets/zhxx.png" alt="" />展会信息
              </div>
              <div class="details" @click="detail('/earlywar/exhibition', '展会信息')">
                更多<span>></span>
              </div>
            </div>
            <!-- <img src="../assets/association.png" alt=""> -->
          </div>
          <div class="dashed"></div>
          <div class="all">
            <div class="all_l">
              <div class="new_line" v-for="(item, index) in xh" :key="index"
                @click="xhDetail(item, '/naturals/companyNotice', '协会通知')">
                <div class="round"></div>
                <div class="font">{{ item.n_title }}</div>
                <div class="new" v-if="item.n_new == 'true'"></div>
                <div class="news" v-else></div>
              </div>
            </div>
            <div class="all_center"></div>
            <div class="all_r">
              <div class="new_line" v-for="(item, index) in zh" :key="index"
                @click="zhDetail(item, '/earlywar/exhibition', '展会信息')">
                <div class="round"></div>
                <div class="font">{{ item.n_title }}</div>
                <div class="new" v-if="item.n_new == 'true'"></div>
                <div class="news" v-else></div>
              </div>
            </div>
          </div>
          <div class="notice_title" style="margin-left:0rem;">
            <div class="left">
              <div class="title">
                <img src="../assets/jc-icon.png" alt="" />精彩图集
              </div>
            </div>
            <div class="left">
              <div class="title" style="margin-left: 6rem"></div>
              <div class="details" @click="detail('/news', '协会活动')">更多<span>></span></div>
            </div>
            <!-- <img src="../assets/association.png" alt=""> -->
          </div>
          <div class="swip">
            <div class="solid_l" @click="pre">
              <img src="../assets/right.png" alt="" />
            </div>
            <div class="solid_c">
              <div class="scroll" :style="{
                width: 35.6 * solid.length + 'rem',
                left: -left + 'rem',
              }">
                <div class="solid_child" v-for="(item, index) in solid" :key="index" @click="notice(item)">
                  <div class="img">
                    <img :src="`http://www.fastener-cn.net:80/tzjgjxh/upload${item.file_path}`" alt="" />
                  </div>
                  <div class="font">
                    <div class="title">
                      {{ item.n_title }}
                    </div>
                    <div class="date">发布时间：{{ item.n_createdate }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="solid_r" @click="next">
              <img src="../assets/right.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="box_right">
        <div class="news">
          <div class="new_title">
            <div class="new_l">
              <img src="../assets/new.png" alt="" />
              最新资讯
            </div>
            <div class="new_r" @click="detail('/naturals/companyIndustry', '最新资讯')">更多<span>></span></div>
          </div>
          <div class="new_content">
            <div class="new_line" v-for="(item, index) in zx" :key="index" @click="hyDetail(item, '/naturals/companyIndustry', '最新资讯')">
              <div class="round"></div>
              <div class="font">{{ item.n_title }}</div>
              <div class="new" v-if="item.n_new == 'true'"></div>
              <div class="newss" v-else></div>
            </div>
          </div>
          <div class="status" @click="notice(keynote)">
          
             <div class="qr">
                  <img src="../assets/qr.jpg">
                <!-- <img :src="`http://www.fastener-cn.net:80/tzjgjxh/upload${keynote.file_path}`" alt=""> -->
             </div>
             <p class="qr_text">扫一扫</p>
             <div class="qr_text">
              {{ keynote.n_title }}
             </div>
        
          </div>
          <div class="status_font" @click="notice(keynote)">
            <!-- {{ keynote.n_title }} -->
          </div>
          <div class="status_line"></div>

          <div class="contactus" @click="contactus"></div>


          <div class="apply" @click="apply"></div>
        </div>
      </div>
    </div>
    <div class="recommend" style="margin-right: 23.6rem">
      <div class="left">
        <div class="title"><img src="../assets/tjqy.png" alt="" />推荐企业</div>
        <div class="detail" @click="hyDetail({ sid: '389898' }, '/directory/production', '企业名录')">更多</div>
      </div>
      <div class="dashed"></div>
      <div class="auto">
        <div class="auto_scroll" ref="auto" :style="{ width: list.length * 35 + 'rem', left: auto_left + 'px' }"
          @mouseenter="stop" @mouseleave="leave">
          <div class="child" v-for="(item, index) in list" :key="index" @click="comDetail(item)">
            <div class="child_img">
              <img :src="`http://www.fastener-cn.net:80/tzjgjxh/upload/${item.file_path}`" />
            </div>
            <div class="child_title">{{ item.company_name }}</div>
            <div class="child_des">{{ item.main_business }}</div>
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
import { reactive, toRefs, ref } from "@vue/reactivity";
import { onMounted, watch, onUnmounted, getCurrentInstance } from "vue";
import footers from '@/components/footer.vue'
import { useRouter } from "vue-router";
import {
  getListZx,
  getExibitionList,
  getAssociationNotice, getRecommended, getWonderfulAtlas
} from "@/api/index.js";
// @ is an alias to /src
export default {
  name: "HomeView",
  components: {
    footers
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const data = reactive({
      xh: [],
      zh: [],
      zx: [],
      list: [

      ],
      keynote: {
        n_title: '关注我们,获取更多资料'
      },
      renderZl: [],
      solid: [
      ],
      Carousel: [
        // { img: require("@/assets/s.jpg") },
        // { img: require("@/assets/t.jpg") },
        // { img: require("@/assets/subject.png") },
          { img: require("@/assets/banner1.jpg") },
        { img: require("@/assets/banner2.jpg") },
        { img: require("@/assets/banner3.jpg") },
      ],
      left: 0,
      index: 0,
      auto_left: Number,
      menu_name: "首页",
    });
    const auto = ref(null);
    const timer = ref(null);
    function auto_set() {
      let spa = -2;
      if (auto.value.offsetLeft < -(auto.value.offsetWidth / 2)) {
        auto.value.style.left = "0";
      }
      if (auto.value.offsetLeft > 0) {
        data.auto_left = -auto.value.offsetWidth / 2 + "px";
      }

      data.auto_left = auto.value.offsetLeft + spa;
    }
    function contactus() {
      router.push({
        path: "/about",
        query: {
          contactus: "在线留言",
        },
      });
    }
    function apply() {
      router.push({
        path: "/about/join",
        query: {
          apply: "入会申请",
        },
      });
    }
    watch(
      data.solid.length,
      (news) => {

      },
      {
        immediate: true,
      }
    );
    function comDetail(item) {
   
      router.push({
        path: '/directory/production',
        query: {
          ksid: item.ksid,
          company_img_path: item.company_img_path,
          product: item.product_img_path
        }
      })
    }
    function notice(item) {

      if (item.mod == '协会活动') {
        router.push({
          path: '/news',
          query: {
            ksid: item.sid,
            xhhd: '协会活动'
          }
        })
      } else if (item.mod == '协会通知') {
        router.push({
          path: 'news',
          query: {
            xhsid: item.sid
          }
        })
      } else if (item.mod == '最新资讯') {
        router.push({
          path: 'news',
          query: {
            hysid: item.sid,
            name: '最新资讯'
          }
        })
      } else {
        //展会信息
        router.push({
          path: '/earlywar/exhibition',
          query: {
            zhsid: item.sid
          }
        })
      }


    }
    function der(ta) {
      if (ta) {
        data.renderZl = ta.data || [];
        const nums = Math.ceil(window.innerWidth / (210 + 20)) * 2;
        data.renderZl = [];
        for (let i = 0; i < Math.ceil(nums / data.list.length); i++) {
          data.list = [...data.renderZl, ...data.list];
        }
      }
    }
    function pre() {
      console.log(data.index, data.solid.length);
      if (data.index == 0) {
        data.index = 0;

        data.left = data.index * 31.7;
      } else {
        data.index--;
        data.left = data.index * 31.7;
      }
    }
    function next() {
      console.log(data.index, data.solid.length);
      if (data.solid.length - 4 < data.index) {
        data.index = 0;

        data.left = data.index * 31.7;
      } else {
        data.index++;
        data.left = data.index * 31.7;
      }
    }
    function stop() {
      clearInterval(timer.value);
    }
    function leave() {
      timer.value = setInterval(() => {
        auto_set();
      }, 30);
    }
    function detail(url, name) {
      router.push({
        path: url,
        query: {
          name,
        },
      });
    }

    function zhDetail(item, url, name) {
      router.push({
        path: url,
        query: {
          name,
          zhsid: item.sid,
        },
      });
    }
    function xhDetail(item, url, name) {
      router.push({
        path: url,
        query: {
          name,
          xhsid: item.sid,
        },
      });
    }
    function hyDetail(item, url, name) {
      router.push({
        path: url,
        query: {
          name,
          hysid: item.sid,
        },
      });
    }
    onMounted(() => {
      //  getWonderfulAtlas({ parms: JSON.stringify({}) }).then(res =>{
      //    console.log(res,'最新图集')
      //  })
      getWonderfulAtlas({}).then(res => {

        data.solid = res.dataList
        // data.keynote = res.zdtjlist
      })
      getRecommended({}).then(res => {

        data.list = [...res.dataList, ...res.dataList]

      })
      timer.value = setInterval(() => {
        auto_set();
      }, 30);
      getListZx({ parms: JSON.stringify({ pageIndex: 1, pageSize: "9" }) }).then((res) => {
        data.zx = res.datalist;
      });
      getAssociationNotice({ parms: JSON.stringify({}) }).then((res) => {
        data.xh = res.datalist;
      });
      getExibitionList({ parms: JSON.stringify({}) }).then((res) => {
        data.zh = res.datalist;
      });
      // der({
      //   data: [
      //     { img: require("../assets/scroll1.png") },
      //     { img: require("../assets/scroll2.png") },
      //     { img: require("../assets/scroll3.png") },
      //     { img: require("../assets/scroll4.png") },
      //     { img: require("../assets/scroll4.png") },

      //   ],
      // });
    });
    onUnmounted(() => {
      clearInterval(timer.value);
    });
    return {
      ...toRefs(data),
      der,
      pre,
      next,
      detail,
      router,
      auto_set,
      auto,
      timer,
      stop,
      leave,
      proxy,
      xhDetail,
      hyDetail,
      zhDetail,
      apply, contactus, comDetail, notice
    };
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-carousel__arrow {
    top: 83%;
  }
}

.home {
  width: 100%;
  height: auto;

  .footer {
    height: 21.8rem;
    background: #ffffff;
    width: 100%;
    margin-bottom: 3rem;

    .center {
      width: 60rem;
      height: 21.8rem;
      font-size: 1.8rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 3.2rem;
      margin: 0 auto;

      overflow: hidden;

      .left {
        height: 5.2rem;
        width: 30rem;
        background-image: url(../assets/logo.png);
        background-size: 100%, 100%;
        background-repeat: no-repeat;

        margin: 0 auto;
        margin-top: 3.3rem;
        margin-bottom: 1rem;
      }

      .phone {
        span {
          color: #5690c3;
          margin-left: 0.6rem;
        }
      }

      .copy {
        width: 60rem;

        font-size: 1.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 3.2rem;
        margin: 0 auto;
      }

      .put {
        margin: 1rem 0;
      }
    }
  }

  .about {
    display: flex;
    margin-top: 5rem;
    align-items: center;
    height: 8.2rem;
    padding-left: 16rem;
    background: #4a506b;
    font-size: 2rem;
    height: 8.2rem;
    font-family: SourceHanSansCN-normal, SourceHanSansCN;
    font-weight: normal;
    color: #ffffff;

    span {
      font-size: 1rem;
      margin-left: 1rem;
    }

    .txt {
      margin-left: 50px;
      font-size: 2rem;
      height: 8.2rem;
      font-family: SourceHanSansCN-normal, SourceHanSansCN;
      font-weight: normal;
      color: #ffffff;
      text-align: left;
      display: flex;
      opacity: 0.8;

      span {
        font-size: 1rem;
        margin-left: 1rem;
        margin-right: 1rem;
      }

      align-items: center;
    }
  }

  .recommend {
    height: 44.8rem;
    background: #fff;
    border-radius: 1rem;
    margin-left: 26.8rem;
    margin-top: 3rem;
    margin-right: 26.8rem;
    border: 0.1rem solid #e6e6e6;

    .auto {
      margin-left: 3.8rem;
      margin-right: 6.8rem;
      // background: red;
      height: 41rem;
      margin-bottom: 5rem;
      margin-top: 5rem;
      overflow: hidden;
      position: relative;
      cursor: pointer;

      @keyframes slideIn {
        0% {
          transform: translateX(-280rem);
        }

        100% {
          transform: translateX(0%);
        }
      }

      .auto_scroll {
        display: flex;
        width: 175rem;
        position: absolute;

        //  animation: slideIn 15s linear infinite;
        .child {
          width: 32rem;
          height: 40rem;

          margin-left: 3rem;

          .child_img {
            width: 32rem;
            height: 19rem;

            img {
              width: 100%;
              height: 100%;
            }
          }


          &:first-child {
            margin-left: 0;
          }
        }

        .child_title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #222222;
          line-height: 28px;
          text-align: left;
          margin-top: 1rem;
        }

        .child_des {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 28px;
          text-align: left;
          text-overflow: ellipsis;
          white-space: normal;
          width: 94%;
        }
      }
    }

    .dashed {
      height: 4px;

      background-image: url(../assets/line.png);
      // background-size: 100%, 100%;
      // background-repeat: no-repeat;
      margin-left: 3rem;

      margin-right: 2.8rem;
    }

    .left {
      margin-left: 3rem;
      width: 95%;
      height: 2rem;
      font-size: 2rem;
      font-family: SourceHanSansCN-normal, SourceHanSansCN;
      font-weight: normal;
      color: #000000;

      .title {
        height: 8rem;
        display: flex;
        color: #222222;
        justify-content: center;
        align-items: center;

      }

      .detail {
        height: 1.4rem;
        font-size: 1.4rem;
        font-family: SourceHanSansCN-normal, SourceHanSansCN;
        font-weight: normal;
        color: #000000;
        margin-right: 3rem;
        cursor: pointer;
      }

      .details {
        height: 1.4rem;
        font-size: 1.4rem;
        font-family: SourceHanSansCN-normal, SourceHanSansCN;
        font-weight: normal;
        color: #000000;
      }

      height: 8rem;

      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        height: 4rem;
        width: 5rem;

        margin-right: 2rem;
      }
    }
  }

  .box {
    height: 138rem;
    margin-left: 26.8rem;
    margin-top: 3rem;
    margin-right: 26.8rem;
    display: flex;

    .box_left {
      width: 100rem;
      height: 147rem;

      .subject {
        width: 100rem;
        height: 47rem;
        background: #ffffff;
        border-radius: 1rem;

        background-repeat: no-repeat;

        img {
          border-radius: 10px;
          width: 100%;
          height: 100%;
        }
      }

      .notice {
        height: 46rem;
        background: #ffffff;
        border-radius: 1rem;
        border: 0.1rem solid #e6e6e6;

        margin-top: 3rem;

        .all {
          height: 37.9rem;
          margin-left: 3rem;

          display: flex;

          margin-right: 2.8rem;

          .all_center {
            width: 0.2rem;
            height: 30.45rem;
            background-image: url(../assets/line.png);
            margin-top: 2.1rem;
          }

          .all_l {
            width: 50%;
            height: 37.9rem;

            .new_line {
              margin-right: -1.9rem;

              .new {
                width: 20px;

                height: 20px;

                background: url(../assets/new.gif) no-repeat;
                background-size: 100%, 100%;
                margin-right: 2rem;
                margin-top: 1.7rem;
              }

              .news {
                width: 20px;

                height: 20px;

                margin-right: 2rem;
                margin-top: 1.7rem;
              }

              margin-left: 2rem;
              height: 5rem;
              border-bottom: 0.1rem solid #e6e6e6;
              display: flex;
              font-size: 1.4rem;
              font-family: SourceHanSansCN-normal,
              SourceHanSansCN;
              font-weight: normal;
              color: #666666;
              align-items: center;
              cursor:pointer;

              &:last-child {
                border-bottom: none;
              }

              .round {
                width: 0.6rem;
                height: 0.6rem;
                border-radius: 50%;
                background: #666666;
                margin-right: 1rem;
              }

              &:hover {
                color: #1890ff;


              }

              .font {
                width: 80%;
                overflow: hidden;
                text-align: left;
                text-overflow: ellipsis;
                font-size: 1.8rem;
                white-space: nowrap;
              }
            }
          }

          .all_r {
            width: 50%;
            height: 37.9rem;

            .new_line {
              margin-right: -1.7rem;

              .new {
                width: 20px;

                height: 20px;

                background: url(../assets/new.gif) no-repeat;
                background-size: 100%, 100%;
                margin-right: 2rem;
                margin-top: 1.7rem;
              }

              .news {
                width: 20px;

                height: 20px;

                margin-right: 2rem;
                margin-top: 1.7rem;
              }

              margin-left: 6rem;
              height: 5rem;
              border-bottom: 0.1rem solid #e6e6e6;
              display: flex;
              font-size: 1.4rem;
              font-family: SourceHanSansCN-normal,
              SourceHanSansCN;
              font-weight: normal;
              color: #666666;
              align-items: center;
              cursor:pointer;

              &:last-child {
                border-bottom: none;
              }

              &:hover {
                color: #1890ff;


              }

              .round {
                width: 0.6rem;
                height: 0.6rem;
                border-radius: 50%;
                background: #666666;
                margin-right: 1rem;
              }

              .font {
                width: 80%;
                overflow: hidden;
                text-align: left;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 90%;
                font-size: 1.8rem;
              }
            }
          }
        }

        .dashed {
          height: 4px;

          background-image: url(../assets/line.png);
          // background-size: 100%, 100%;
          // background-repeat: no-repeat;
          margin-left: 3rem;

          margin-right: 2.8rem;
        }

        .swip {
          width: 100%;
          height: 33.5rem;
          background: #f2f5f9;
          border-radius: 0.5rem;

          display: flex;

          .solid_l {
            width: 4.8rem;
            height: 31rem;
            background: #ffffff;
            border-radius: 0.5rem;
            border: 0.1rem solid #e6e6e6;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            img {
              width: 1.27rem;
              height: 1.27rem;
              transform: rotateZ(180deg);
            }
          }

          .solid_c {
            height: 33.5rem;
            width: 103rem;
            margin-left: 2rem;
            margin-right: 2rem;
            display: flex;
            border-radius: 1rem 1rem 1rem 1rem;
            position: relative;
            overflow: hidden;

            .scroll {
              display: flex;
              margin-right: 0rem;
              width: 106rem;
              position: absolute;
              left: 0rem;
              margin-top: .5rem;
              transition: all 0.3s;

              .solid_child {
                width: 28rem;
                margin-right: 2.2rem;
                height: 30.5rem;
                overflow: hidden;

                .img {
                  width: 28rem;
                  height: 19rem;
                  border-radius: 1rem 1rem 1rem 1rem;

                  img {
                    width: 100%;
                    height: 100%;
                  }
                }

                .font {
                  width: 28rem;
                  height: 11.5rem;
                  background: #fff;
                  border-radius: 0rem 0rem 1rem 1rem;
                  overflow: hidden;

                  .title {
                    height: 5.6rem;
                    font-size: 1.4rem;
                    font-family: SourceHanSansCN-normal, SourceHanSansCN;
                    font-weight: normal;
                    color: #222;
                    line-height: 2.8rem;
                    text-align: left;
                    margin-top: 1rem;
                    padding-left: 2rem;
                    width: 83%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                  }

                  .date {
                    height: 2.8rem;
                    font-size: 1.4rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;

                    margin-left: 2rem;
                    text-align: left;
                    margin-top: 0.5rem;
                    line-height: 2.8rem;
                  }
                }
              }
            }
          }

          .solid_r {
            width: 4.8rem;
            height: 31rem;
            background: #ffffff;
            border-radius: 0.5rem;
            border: 0.1rem solid #e6e6e6;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            img {
              width: 1.27rem;
              height: 1.27rem;
            }
          }
        }

        .notice_title {
          height: 8rem;
          margin-left: 3rem;

          margin-right: 2.8rem;

          display: flex;

          .left {
            width: 50%;
            height: 2rem;
            font-size: 2rem;
            font-family: SourceHanSansCN-normal, SourceHanSansCN;
            font-weight: normal;
            color: #000000;
            cursor: pointer;

            .title {
              height: 8rem;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .detail {
              height: 1.4rem;
              font-size: 1.4rem;
              font-family: SourceHanSansCN-normal, SourceHanSansCN;
              font-weight: normal;
              color: #000000;
              margin-right: 3rem;
            }

            .details {
              height: 1.4rem;
              font-size: 1.4rem;
              font-family: SourceHanSansCN-normal, SourceHanSansCN;
              font-weight: normal;
              color: #000000;
            }

            height: 8rem;

            display: flex;
            align-items: center;
            justify-content: space-between;

            img {
              height: 4rem;
              width: 5rem;

              margin-right: 2rem;
            }
          }
        }
      }
    }

    .box_right {
      width: 40rem;
      height: 147rem;
      margin-left: 3rem;

      .news {
        width: 36.4rem;
        height: 57rem;
        background: #ffffff;
        border-radius: 1rem;
        border: 0.1rem solid #e6e6e6;

        .status {
          width: 36.4rem;
          height: 35.8rem;

          margin-top: 11rem;
          overflow: hidden;
          cursor: pointer;               border-radius: 1rem;
          .qr{
          
            margin:0 auto;
            margin-top:6rem;
            width: 181px;
    height: 181px;

          }
    background: #ffffff;
    .qr_text{
      font-size: 17px;color: #666666;
    }
          img {
            width: 100%;
            height: 100%;

            background-size: 100%, 100%;
          }
        }

        .status_font {
          width: 36.4rem;
          height: 1.6rem;
          font-size: 1.4rem;
          font-family: SourceHanSansCN-normal, SourceHanSansCN;
          font-weight: normal;
          color: #000000;
          line-height: 2.8rem;
          text-align: left;
          margin-top: 2rem;
          cursor: pointer;
        }

        .apply {
          width: 40rem;
          height: 5.2rem;

          border-radius: 0.5rem;
          border: 0.1rem solid #e6e6e6;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          font-family: SourceHanSansCN-normal, SourceHanSansCN;
          font-weight: normal;
          color: #ffffff;
          margin-top: 0.9rem;

          img {
            width: 2.1rem;
            margin-left: 0.3rem;
            height: 2.1rem;
          }
        }

        .textarea {
          width: 40rem;

          background: #ffffff;
          overflow: hidden;
          // border: 0.1rem solid #E6E6E6;
          border-bottom-left-radius: 1rem;
          border-bottom-right-radius: 1rem;

          textarea {
            resize: none;
            /* 取消拖拽 */
            outline: none;
          }

          .btn {
            width: 23.3rem;
            height: 4.5rem;
            background: #1890ff;
            border-radius: 3.1rem;
            margin: 0 auto;
            margin-top: 13rem;
            margin-bottom: 2.7rem;
            font-size: 1.8rem;
            font-family: SourceHanSansCN-normal, SourceHanSansCN;
            font-weight: normal;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .iptbig {
            height: 4.2rem;

            margin-left: 1.9rem;
            margin-top: 2rem;
            margin-right: 1.9rem;

            display: flex;
            justify-content: space-between;

            .txt {
              width: 7rem;

              font-size: 1.4rem;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #999999;
              line-height: 2.1rem;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .input {
              width: 28.2rem;
              height: 12rem;
              background: #efefef;
              border-radius: 0.5rem;
              outline: none;
              padding-left: 1rem;
              padding-top: 1.5rem;
              border: none;
            }
          }

          .ipt {
            height: 4.2rem;

            margin-left: 1.9rem;
            margin-top: 2rem;
            margin-right: 1.9rem;

            display: flex;
            justify-content: space-between;

            .txt {
              width: 7rem;

              font-size: 1.4rem;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #999999;
              line-height: 2.1rem;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .input {
              width: 28.2rem;
              height: 4.2rem;
              background: #efefef;
              border-radius: 0.5rem;
              outline: none;
              padding-left: 1rem;
              border: none;
            }
          }
        }

        .status_line {
          width: 36.4rem;
          height: 4px;
          background-image: url(../assets/line.png);
          margin-top: 1.6rem;
          margin-bottom: 2.9rem;
          // margin-bottom: 13rem;
        }

        .contactus {
          width: 36.4rem;
          height: 13.7rem;
          background: url(../assets/contactus.png) no-repeat;
          margin-top: 1.6rem;
          margin-bottom: 3rem;
          background-size: 100% 100%;
          cursor: pointer;
        }

        .apply {
          width: 36.4rem;
          height: 13.7rem;
          background: url(../assets/apply.png) no-repeat;
          margin-top: 1.6rem;
          margin-bottom: 3rem;
          background-size: 100% 100%;
          cursor: pointer;
        }

        .new_content {
          width: 100%;
          height: 43.8rem;

          .new_line {
            margin-right: -.3rem;

            margin-left: 2rem;
            height: 5rem;
            border-bottom: 0.1rem solid #e6e6e6;
            display: flex;
            font-size: 1.4rem;
            font-family: SourceHanSansCN-normal, SourceHanSansCN;
            font-weight: normal;
            color: #666666;
            align-items: center;
            cursor: pointer;

            .new {
              width: 20px;

              height: 20px;

              background: url(../assets/new.gif) no-repeat;
              background-size: 100%, 100%;
              margin-right: 2rem;
              margin-top: 1.7rem;
            }

            .newss {
              width: 20px;

              height: 20px;

              margin-right: 2rem;
              margin-top: 1.7rem;
            }

            .round {
              width: 0.6rem;
              height: 0.6rem;
              border-radius: 50%;
              background: #666666;
              margin-right: 1rem;
            }

            &:hover {
              color: #1890ff;


            }

            .font {
              width: 90%;
              overflow: hidden;
              text-align: left;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 1.7rem;
            }
          }
        }

        .new_title {
          width: 100%;
          height: 5.3rem;
          background: #1890ff;
          border-radius: 1rem 1rem 0rem 0rem;
          display: flex;
          justify-content: space-between;


          .new_l {
            width: 14rem;
            height: 5.3rem;
            display: flex;
            font-size: 2rem;
            font-family: SourceHanSansCN-normal, SourceHanSansCN;
            font-weight: normal;
            color: #ffffff;
            align-items: center;

            img {
              margin-left: 2.1rem;
              width: 3.4rem;
              margin-right: 0.2rem;
              height: 3.4rem;
            }
          }

          .new_r {
            height: 5.3rem;
            display: flex;
            align-items: center;
            font-size: 1.4rem;
            font-family: SourceHanSansCN-normal, SourceHanSansCN;
            margin-right: 2.1rem;
            font-weight: normal;
            color: #ffffff;
            line-height: 2.1rem;
          }
        }
      }
    }
  }
}
</style>
